import { ChangeDetectorRef, Component, OnInit, TemplateRef, QueryList, ViewChildren,ViewChild } from '@angular/core';
import { CdkDragDrop, CdkDrag, CdkDropList, moveItemInArray, transferArrayItem, CdkDragEnter, CdkDragExit, CdkDragStart } from '@angular/cdk/drag-drop';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { SignaturePad } from 'angular2-signaturepad';
import { FormsService } from '../services/forms.service';
import { Router } from '@angular/router';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { asapScheduler, asyncScheduler, Observable, Subscription } from 'rxjs';
import { ConfirmDialogModel,ConfirmDialogComponent} from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FilteredContactVm } from 'src/app/viewModels/core/contacts-vm';
import { map, startWith } from 'rxjs/operators';
import { CCCName } from '../services/form.enum';
import { Add3ctypeformComponent } from 'src/app/middleware/common/add3ctypeform/add3ctypeform.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-step-two',
  templateUrl: './step-two.component.html',
  styleUrls: ['./step-two.component.scss']
})


export class StepTwoComponent implements OnInit {
  public editorConfig = {
    versionCheck: false
  };
  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  approver:boolean=true;
  groupName: any;
  databaseId: string;
  organizationId: string;
  currentUser: any;
  selectedRecordDeleteArray: any;
  responseHolder: any;
  parentID: any;
  selection: any;
  showFavDeletePanel: boolean;
  projectGroups:any= [];
  viewOnlyAndSendFinalCompy: any;
  viewOnlylist: any = [];
  SendFinalCopy: any = [];

  updateGroupNameForm: FormGroup;
  updateRelationColorForm: FormGroup;
  addGroupNameForm: FormGroup;
  relationColour: string = '';
  relationID: number;
  groupRelationParticipantMappingID: number;
  groupID: number;
  projectID: number;
  groupType: any;
  transRoleList: any = [];
  isRolePopup: boolean = false;
  currentRoleContact: any;
  Roles: any = [];
  showContactRoleAddButton = false;
  isShare: boolean = false;
  peoples: any = [];
  isSharedAccessRolePopup: boolean = false;
  selectedsharedAccessRole: any = [];
  showAddButton: boolean = false;
  contactsList: any = [];
  sharedAccessRoleList: any = [];
  SharedRoleList: any = [];
  selectedcolorOnUpdate: string = "";
  addRelationForm: FormGroup;
  colorcodeExist: any = [];
  transactionalRoleName: string = "";
  colourCode: any = [];
  UpdateRelationColorButton: boolean = false;
  dynamicForm: FormGroup;
  checkDuplicateColor: any = [];
  SubmitNextButtonDisabled: boolean = false;
  clickEventsubscription: Subscription;
  mainModuleName:string="";
  Module:string="";
  showAddContact:boolean = false;
  searchName:string='';
  contactemail:any;
  stepCompleted: number=1;
  searchValues:string="";
  ContactIdforUpdateColor:number=0;
  OfficeIDList: any=[];
  myOfficeID: any;
  showAddContactButton:boolean=true;

  stateCtrlValue:string;
  contactNames:string="Email";
  coreNames:string="";
  selectedApprover: boolean=false;
  selectedGroup: any;
  selectedParticipant: any;
  participantMessageInfo:string=null;
  participantMessageInfoBackUp:string=null;
   textNameShow:string="Email";

  constructor(private loaderService: LoaderService, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private toastr: ToastrService, private formService: FormsService,
    private router: Router, private statusConstant: StatusConstant, private dialog: MatDialog,
    private _dataSharingService: DataSharingService, private formBuilder: FormBuilder,
    private filteredContactVm: FilteredContactVm, private cdr: ChangeDetectorRef) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    this.getShortName(this.currentUser.Name);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });

    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''),
      map((state) => (state ? this._filterStates(state) : this.states.slice()))
    );

  }

  private _filterStates(value: string): State[] {    
    const filterValue = value.toLowerCase();
    return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }


  ngOnInit(): void {
    this.dialog.closeAll();
    if(sessionStorage.getItem('stepCompleted')!=undefined){
     this.stepCompleted=Number(sessionStorage.getItem('stepCompleted'));
    }
    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));

    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module =[];
    Module= menuModulesList.filter(x => x.mainModuleName == CCCName.Forms);
    if(Module.length>0){
      this.Module= Module[0].orgModuleName;
    }   

    var menuModulesLists = menuModulesList.filter(x => x.mainModuleName == CCCName.Contact);
    if(menuModulesLists.length>0){
      this.contactNames= menuModulesLists[0].orgModuleName;
      this.ContactShowName= menuModulesLists[0].orgModuleName;
    } 

    var menuModulesLists = menuModulesList.filter(x => x.mainModuleName == CCCName.Core);
    if(menuModulesLists.length>0){
      this.coreNames= menuModulesLists[0].orgModuleName;
      this.CoreShowName= menuModulesLists[0].orgModuleName;
    } 

    var menuModulesLists = menuModulesList.filter(x => x.mainModuleName == CCCName.Company);
    if(menuModulesLists.length>0){
      this.CompanyShowName= menuModulesLists[0].orgModuleName;
    } 
    sessionStorage.setItem('HeaderModuleName',  this.Module);
    sessionStorage.setItem('edashboard', "true");
    
    this.clickEventsubscription = this._dataSharingService.GetProjectNameAlreadyExist().subscribe((result) => {
      if (result != undefined) {
        if(result == true){
          this.SubmitNextButtonDisabled=false;
        }else{
         this.SubmitNextButtonDisabled=true;
        }
      }
    });
   
    var projectID=sessionStorage.getItem('projectID');
    if(projectID==null || projectID==undefined){
      this.router.navigate(['/esignature/first']);
      return;
    }

    this.UpdateRelationColorButton = false;
    if (sessionStorage.getItem('projectID') !== null && sessionStorage.getItem('projectID') !== undefined && sessionStorage.getItem('projectID') !== '0') {
      this.GetGroupList(sessionStorage.getItem('projectID'));
    }
    this.updateGroupNameForm = this.formBuilder.group({
      groupName: ['', [Validators.required]],
    });
    this.addGroupNameForm = this.formBuilder.group({
      groupName: ['', [Validators.required]],
    });
    this.updateRelationColorForm = this.formBuilder.group({
      colourCode: ['']
    });
    
    this.dynamicForm = this.formBuilder.group({
      filters: this.formBuilder.array([]),      
    });
        

    if(sessionStorage.getItem('type')=="1"){
      sessionStorage.setItem('HeaderModuleName', this.Module);
      this._dataSharingService.sendSelectedModuleName(this.Module);
    }
    if(sessionStorage.getItem('type')=="2"){
      sessionStorage.setItem('HeaderModuleName', 'Template');
      this._dataSharingService.sendSelectedModuleName(this.Module);
    }   

    if(sessionStorage.getItem('MasterTemplatePDFForm')=="true"){
       this.showAddContactButton=false;
    }else{
      this.showAddContactButton=true;
    }
    this._dataSharingService.sendShowFormsSiderbar(this.Module);
    this.cdr.detectChanges();    
  }

  showFormEditor(){
    if(this.stepCompleted >2)
    this.router.navigate(['/esignature/third']);
  }

  showFormFinish(){
    if(this.stepCompleted >3)
    this.router.navigate(['/esignature/four']);
  }
  @ViewChild('AddMessage') AddMessage: TemplateRef<any>;
  addMessage() {
    this.participantMessageInfoBackUp=this.participantMessageInfo;
    this.dialog.open(this.AddMessage, { disableClose: true });
  }
  closeMessagePopUp(){
    this.participantMessageInfo=this.participantMessageInfoBackUp;
    this.dialog.closeAll();
  }

  saveMessage(){
    this.dialog.closeAll();
    this.loaderService.show();
    var ReqModel = {
      ProjectID: Number(sessionStorage.getItem('projectID')),
      type: Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
      UserID: this.currentUser.UID,
      OrganizationID: Number(this.organizationId),
      PartcipantMessage:this.participantMessageInfo
    };
    this.formService.UpdatePartcipantMessage(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.GetGroupList(Number(sessionStorage.getItem('projectID')));
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.toastr.success('Message saved successfully.', '', {
            timeOut: 3000,
          });
          this.participantMessageInfoBackUp=this.participantMessageInfo;
          this.loaderService.hide();
         } else {
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
    }

    
  // saveMessage(){
  //   if(this.participantMessageInfo== undefined || this.participantMessageInfo==""){
  //     this.toastr.error('Please enter message.', '', {
  //       timeOut: 3000,
  //     });
  //   }else{
  //     this.dialog.closeAll();
  //     this.loaderService.show();
  //     var ReqModel = {
  //       ProjectID: Number(sessionStorage.getItem('projectID')),
  //       type: Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
  //       UserID: this.currentUser.UID,
  //       OrganizationID: Number(this.organizationId),
  //       PartcipantMessage:this.participantMessageInfo
  //     };
  //     this.formService.UpdatePartcipantMessage(ReqModel).subscribe((response) => {
  //       if (response != undefined) {
  //         this.responseHolder = response;
  //         this.GetGroupList(Number(sessionStorage.getItem('projectID')));
  //         if (this.responseHolder.status == this.statusConstant.statusSuccess) {
  //           this.toastr.success('Message saved successfully.', '', {
  //             timeOut: 3000,
  //           });
  //           this.participantMessageInfoBackUp=this.participantMessageInfo;
  //           this.loaderService.hide();
  //          } else {
  //           this.loaderService.hide();
  //         }
  //       }else{
  //         this.loaderService.hide();
  //       }
  //     });
  //   }
  // }

  addProjectGroup() {
    this.loaderService.show();
    var ReqModel = {
      groupName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      projectID: sessionStorage.getItem('projectID'),
      type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
      OfficeID:this.myOfficeID
    }
    this.formService.AddEditProjectGroup(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();
          this.GetGroupList(sessionStorage.getItem('projectID'));
          this.dialog.closeAll();
          this.addGroupNameForm.reset();
          this.toastr.success('Group Added successfully.', '', {
            timeOut: 3000,
          });
        }
      }
    });
  }


  GetGroupList(projectID: any) {
    this.colourCode;   
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      projectID: projectID,
      type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
      OfficeID:this.myOfficeID
    }
    this.loaderService.show();
    this.formService.GetGroupList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();    
          this.projectGroups = this.responseHolder.data.groupList;//.filter(m=>m.groupType==1);
          this.stepCompleted =this.responseHolder.data.projectDetail.stepCompleted;         
          this.participantMessageInfo =this.responseHolder.data.projectDetail.participantMessageInfo;
          sessionStorage.setItem('ProjectName',this.responseHolder.data.projectDetail.projectName);  
          this._dataSharingService.sendSelectedModuleName('Forms');       
          this.colorcodeExist = [];
          var data = [];
          data = this.projectGroups;
          if (data.length > 0) {
            for (var i = 0, len = data.length; i < len; ++i) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = data[i].projGrpRelationParticipantList;
              for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                var req = {
                  colourCode: projGrpRelationParticipantList[i1].colourCode,
                  transctionalRoleID: projGrpRelationParticipantList[i1].relationID
                }
                this.colorcodeExist.push(req);
              }
            }
          }
          this.colorcodeExist;
          if (this.colorcodeExist.length > 0) {           
            var colorcodes = this.ShowcolourCode;
            let _notExistColor = colorcodes.filter(({ colourCode: id1 }) => !this.colorcodeExist.some(({ colourCode: id2 }) => id2 === id1));
            this.colourCode = _notExistColor.map(s => Object.assign(s));            
          }
          else {
            this.colourCode = this.ShowcolourCode;
          }

          var check=[]         
          check = this.responseHolder.data.groupList.filter(x => x.groupType === 1);
          if(check.length > 0){
            for (var i = 0, len = check.length; i < len; ++i) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = check[i].projGrpRelationParticipantList;
              if(projGrpRelationParticipantList.length > 0){            
               
                this.SubmitNextButtonDisabled=true;
                return;              
              }
              else{                
                this.SubmitNextButtonDisabled=false;
              }              
            }            
          }

          if(check.length == 0){
            this.SubmitNextButtonDisabled=false;
          }

          if(this.SubmitNextButtonDisabled==false){
            check = this.responseHolder.data.groupList.filter(x => x.groupType === 2);
            if(check.length > 0){
              var checkParticipant =check[0].projGrpRelationParticipantList;
              if(checkParticipant.length > 0){               
                this.SubmitNextButtonDisabled=true;
              } else {
                this.SubmitNextButtonDisabled=false;
              }
            }
          }
         
          if(this.SubmitNextButtonDisabled==false){
            check = this.responseHolder.data.groupList.filter(x => x.groupType === 3);
            if(check.length > 0){
              var checkParticipant =check[0].projGrpRelationParticipantList;
              if(checkParticipant.length > 0){               
                this.SubmitNextButtonDisabled=true;
              }else {
                this.SubmitNextButtonDisabled=false;
              }
            }
          }
        }else{
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
  }

 

  renameGroup(templateRef: TemplateRef<any>, group) {
    if (group.groupType == 2 || group.groupType == 3) {
      return;
    }
    this.dialog.open(templateRef);
    this.groupID = group.groupID;
    this.groupType = group.groupType;
    this.projectID = group.projectID;
    this.updateGroupNameForm.get('groupName').setValue(group.groupName);
  }

  //rename Group Name
  UpdateGroupName(formValues) {
    if (formValues !== undefined) {
      let ifExist= this.projectGroups.some(m=>m.groupName.toLowerCase()==formValues.groupName.toLowerCase());
      if(ifExist){
        this.toastr.warning('Group name already exists.', '', {
          timeOut: 3000,
        });
        return;
      }
      
     this.dialog.closeAll();
      var ReqModel = {
        groupID: this.groupID,
        groupName: formValues.groupName,
        projectID: this.projectID,
        groupType: this.groupType,
        isActive: true,
        isDeleted: false,
        userID: this.currentUser.UID,
        databaseID: Number(this.databaseId),
        organizationID: Number(this.organizationId),
        type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
      }
      this.loaderService.show();
      this.dialog.closeAll();
      this.formService.UpdateProjectGroupName(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            this.loaderService.hide();
            this.dialog.closeAll();
            this.GetGroupList(sessionStorage.getItem('projectID'));
            this.toastr.success('Groupname update successfully.', '', {
              timeOut: 3000,
            });
          }else{
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
          this.toastr.warning('Groupname allready exist.', '', {
            timeOut: 3000,
          });
        }
      });
    }
  }

  // delete group
  DeleteGroup(group) {
    const message = `Are you sure you want to delete this group?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          if (group !== undefined) {
            var ReqModel = {
              groupID: group.groupID,
              groupName: group.groupName,
              projectID: group.projectID,
              groupType: group.groupType,
              isActive: false,
              isDeleted: true,
              userID: this.currentUser.UID,
              databaseID: Number(this.databaseId),
              organizationID: Number(this.organizationId),
              type:Number(sessionStorage.getItem('type'))
            }
            this.formService.UpdateProjectGroupName(ReqModel).subscribe((response) => {
              if (response != undefined) {
                this.responseHolder = response;
                if (this.responseHolder.status == this.statusConstant.statusSuccess) {
                  this.loaderService.hide();
                  this.GetGroupList(sessionStorage.getItem('projectID'));
                  this.toastr.success('Group delete successfully.', '', {
                    timeOut: 3000,
                  });
                }else{
                  this.loaderService.hide();
                }
              } else {
                this.loaderService.hide();
              }
            });
          }
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  getTransactinalRoles(searchValue: any) {
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      UserID: this.currentUser.UID,
      searchValue: searchValue,
      PageSize: 0,
      officeID:this.myOfficeID,
      OfficeIDList:this.OfficeIDList
    }
    this.formService.getTransactinalRoles(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.transRoleList = response.data.transactionalRolesModels;
          //this.transRoleList=this.transRoleList.filter(m=>!this.currentRoleContact.trasactionalRoleIds.includes(m.transctionalRoleID));
          var check=[];
          check=this.transRoleList.filter(x=>x.transactionalRoleName.toLowerCase()==searchValue.toLowerCase());
          if(check.length==0){
             this.transRoleList.push(
             {
               "transctionalRoleID":0,
               "coreID":0,
               "transactionalRoleName":searchValue,
             }) 
           }
          // this.transRoleList = response.data.transactionalRolesModels;
          // //  this.transRoleList=this.transRoleList.filter(m=>!this.currentRoleContact.trasactionalRoleIds.includes(m.transctionalRoleID));
          // if (this.transRoleList.length == 0){
          //   this.transRoleList.push(
          //     {
          //       "transctionalRoleID": 0,
          //       "colourCode": "",
          //       "transactionalRoleName": searchValue,
          //     }
          //   )
          // }
           

          //   this.transRoleList.push(
          //     {
          //       "transctionalRoleID": 0,
          //       "colourCode": "",
          //       "transactionalRoleName": "Create New",
          //       "transactionalRoleNames": searchValue,            
          //     }
          //   )
        }
      }
    });
  } 
  

  
  // getTransactinalRoles(searchValue: any) {
  //   var ReqModel = {
  //     DatabaseID: Number(this.databaseId),
  //     OrganizationID: Number(this.organizationId),
  //     UserID: this.currentUser.UID,
  //     searchValue: searchValue,
  //     PageSize: 0,
  //     officeID:this.myOfficeID,
  //     OfficeIDList:this.OfficeIDList
  //   }
  //   this.formService.getTransactinalRoles(ReqModel).subscribe(response => {
  //     if (response != undefined) {
  //       this.responseHolder = response;
  //       if (this.responseHolder.status == this.statusConstant.statusSuccess) {
  //         this.transRoleList = response.data.transactionalRolesModels;
  //         //  this.transRoleList=this.transRoleList.filter(m=>!this.currentRoleContact.trasactionalRoleIds.includes(m.transctionalRoleID));
  //         if (this.transRoleList.length == 0)
  //           this.transRoleList.push(
  //             {
  //               "transctionalRoleID": 0,
  //               "colourCode": "",
  //               "transactionalRoleName": searchValue,
  //             }
  //           )

  //           this.transRoleList.push(
  //             {
  //               "transctionalRoleID": 0,
  //               "colourCode": "",
  //               "transactionalRoleName": "Create New",
  //               "transactionalRoleNames": searchValue,            
  //             }
  //           )
  //       }
  //     }
  //   });
  // } 
  

  RoleSelected(roleSelected: any) {
    if(roleSelected.currentValue.toLowerCase() == roleSelected.currentValue.toLowerCase().match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')){
      return;
    }
    this.colorcodeExist;
    var colourCode = "";
    var data = [];
    
    data  = this.colorcodeExist.filter((s) => s.colourCode == roleSelected.colourCode);
   
    colourCode = "";
    var obj={
      value:1
    }
    this.checkDuplicateColor.push(obj);

    // if (data.length > 0 ) {
    //   colourCode = "";
    //   var obj={
    //     value:1
    //   }
    //   this.checkDuplicateColor.push(obj);
    // }
    // else {
    //   colourCode = roleSelected.colourCode;
   // }

    // if(roleSelected.colourCode == ""){
    //   colourCode = "";
    //   var obj={
    //     value:1
    //   }
    //   this.checkDuplicateColor.push(obj);
    // }
    // if(roleSelected.colourCode != "" ){
    //   if (data.length > 0 ) {
    //     colourCode = "";
    //     var obj={
    //       value:1
    //     }
    //     this.checkDuplicateColor.push(obj);
    //   }
    //   else {
    //     colourCode = roleSelected.colourCode;
    //   }
    // }  
    
    if(this.dynamicForm.value.filters.length > 0){
      var check =[];
       check= this.dynamicForm.value.filters.filter((s) => s.colourCode == roleSelected.colourCode);
      // if(check.length > 0){
      //   colourCode = "";
      //   var obj={
      //     value:1
      //   }
      //   this.checkDuplicateColor.push(obj);
      // }
    }
    
    if (colourCode == "" && roleSelected.transctionalRoleID==0) {
      colourCode = this.colourCode[this.checkDuplicateColor.length -1].colourCode;
    }
    else if(roleSelected.transctionalRoleID>0)
    {
      colourCode=roleSelected.colourCode;
    }
    let role = {
      transactionalRoleName: roleSelected.transactionalRoleName,
      transctionalRoleID: roleSelected.transctionalRoleID,
      colourCode: colourCode//roleSelected.colourCode
    };
    var AddData=[];
    AddData.push(role);
    this.Roles.push(role);
    
    // if (this.Roles.length > 0) {
    //   var data = [];
    //   data = this.Roles.filter((e) => e.colourCode == '');
    //   if (data.length > 0) {
    //     this.showContactRoleAddButton = false;
    //   }
    //   else {
    //     this.showContactRoleAddButton = true;
    //   }
    // }
    // if (this.Roles.length == 0) {
    //   this.showContactRoleAddButton = false;
    // }
    
    // var colorcodes = this.ShowcolourCode;
    // let _notExistColor = colorcodes.filter(({ colourCode: id1 }) => !this.colorcodeExist.some(({ colourCode: id2 }) => id2 === id1));
    // this.colourCode = _notExistColor.map(s => Object.assign(s));

    
    AddData.forEach(seedDatum => {
      const formGroup = this.createFilterGroup();
      if (seedDatum.transactionalRoleName) {
        formGroup.addControl('value', this.getFormControl());
      }
      formGroup.patchValue(seedDatum);
      this.filtersFormArray.push(formGroup);
    });
    if(this.filtersFormArray.length > 0){
      this.showContactRoleAddButton = true;
    }
    if(this.filtersFormArray.length == 0){
      this.showContactRoleAddButton = false;
    }
  }

  get filtersFormArray() {
    return (<FormArray>this.dynamicForm.get('filters'));
  }

  getFormControl() {
    return this.formBuilder.control(null);
  }
  
  createFilterGroup() {
    return this.formBuilder.group({
      colourCode: [],
      transactionalRoleName:'',
      transctionalRoleID:0
    });
  }
  

  RoleSelectedForSharedAccess(roleSelected: any) {
    if (this.selectedsharedAccessRole.length > 0) {
      return;
    }
    this.selectedsharedAccessRole.push({
      name: roleSelected.roleName,
      email: '',
      img: '',
      contactID: 0,
      roleID: roleSelected.roleID,
      isShared: this.isShare,
      shortName: ''
    });

    if (this.selectedsharedAccessRole.length > 0) {
      this.showAddButton = true;
    }
    if (this.selectedsharedAccessRole.length == 0) {
      this.showAddButton = false;
    }
  }


  removeItemRoleParticipant(item: any, isSharedAccessRolePopup: boolean) {
    if (this.isSharedAccessRolePopup) {
      const index = this.selectedsharedAccessRole.indexOf(item);
      if (index >= 0) {
        this.selectedsharedAccessRole.splice(index, 1);
      }
      if (this.selectedsharedAccessRole.length > 0) {
        this.showAddButton = true;
      }
      if (this.selectedsharedAccessRole.length == 0) {
        this.showAddButton = false;
      }
    }
  }

  removeItem(item: any, isRolePopup: boolean) {
    if (this.isRolePopup) {
      this.filtersFormArray.removeAt(item);

      const index= this.dynamicForm.value.filters.indexOf(item)
     // this.checkDuplicateColor = this.checkDuplicateColor.length - this.filtersFormArray.length;
      //const index = this.Roles.indexOf(item);
      if (index >= 0) {
        this.dynamicForm.value.filters(index, 1);
       // this.Roles.splice(index, 1);
      }
    }
    else {
      const index = this.peoples.indexOf(item);
      if (index >= 0) {
        this.peoples.splice(index, 1);
      }
    }
    if (this.peoples.length == 0) {
      this.showAddButton = false;
    }
    // if (this.Roles.length > 0) {
    //   var data = [];
    //   data = this.Roles.filter((e) => e.colourCode == '');
    //   if (data.length > 0) {
    //     this.showContactRoleAddButton = false;
    //   }
    //   else {
    //     this.showContactRoleAddButton = true;
    //   }
    // }

    
    //this.filtersFormArray.removeAt(item);

    if (this.filtersFormArray.length > 0) {
      this.showContactRoleAddButton = true;
    }

    if (this.filtersFormArray.length == 0) {
      this.showContactRoleAddButton = false;
    }
    if (this.colorcodeExist.length > 0) {
      let _notExistColor = this.colourCode.filter(({ colourCode: id1 }) => !this.colorcodeExist.some(({ colourCode: id2 }) => id2 === id1));
      this.colourCode = _notExistColor.map(s => Object.assign(s));
    }
  }


  removeCore(item: any) {    
   const index = this.selectCoreList.indexOf(item);
    if(index >= 0) {
      this.selectCoreList.splice(index, 1);
     }    
    if(this.selectCoreList.length == 0) {
       this.showAddButton = false;      
     }
     this.showSearchCore=true;
   }


  addRelation(templateRef: TemplateRef<any>, group) {
    this.dialog.open(templateRef, {
      panelClass: 'selectParticipants',
    });

    this.transRoleList = [];
    this.Roles = [];
    this.showContactRoleAddButton = false;

    this.isRolePopup = true;
    this.groupName = group.groupName;
    this.groupID = group.groupID;
    this.groupType = group.groupType;
    this.projectID = group.projectID;
    this.dynamicForm = this.formBuilder.group({
      filters: this.formBuilder.array([]),
      transactionalRoleName:''
    });    
  }

  
  addRelationsNew(group){    
    
    this.transRoleList = [];
    this.Roles = [];
    this.showContactRoleAddButton = false;

    this.isRolePopup = true;
    this.groupName = group.groupName;
    this.groupID = group.groupID;
    this.groupType = group.groupType;
    this.projectID = group.projectID;

    var colorGroup:any=[]=[];
    var colorsCode:string=""
    var filteredColorCodes:any=[]=[];
    var projGrpRelationParticipantList:any=[]=[];

    if(this.projectGroups.length>0){
     // 👉 Extract all participants into another list
      projGrpRelationParticipantList = this.projectGroups
     .map(g => g.projGrpRelationParticipantList || []) // collect each group's participants
     .flat(); // flatten into a single array
    }
    
    colorGroup = projGrpRelationParticipantList;//this.projectGroups;//group.projGrpRelationParticipantList;
    if(colorGroup.length>0){
      const excludedColors = colorGroup.map((participant) => participant.colourCode);
      filteredColorCodes = this.ShowcolourCode.filter((color) => !excludedColors.includes(color.colourCode));
      if(filteredColorCodes.length>0){
        colorsCode=filteredColorCodes[0].colourCode;
      }
    }else{
      colorsCode="#FF9E80";
    }
    var relationListModels = [];
    var req = {
      groupRelationParticipantMappingID: 0,
      groupID: group.groupID,
      contactID: null,
      relationID: 0,
      relationName: "Participant",
      projectID: group.projectID,
      roleID: null,
      colourCode: colorsCode,
     }
     relationListModels.push(req)

      var ReqModel = {
        relationListModels: relationListModels,
        userID: this.currentUser.UID,
        databaseID: Number(this.databaseId),
        organizationID: Number(this.organizationId),
        type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
        OfficeID:this.myOfficeID
      }      
      this.loaderService.show();
      this.formService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            this.transRoleList = [];
            this.dialog.closeAll();
            this.GetGroupList(sessionStorage.getItem('projectID'));
            this.toastr.success('Relation added successfully.', '', {
              timeOut: 3000,
            });
            this.close();            
            this.loaderService.hide();
          }else{
            this.transRoleList = [];
            this.dialog.closeAll();
          }
        }
      });
    
  }

  AddRelations() {
    if (this.filtersFormArray.length> 0) {
      this.dynamicForm.value;   
      this.AddEditProjectGroupRelationParticipant();
    }
  }

  AddEditProjectGroupRelationParticipant() {
    if (this.filtersFormArray.length > 0) {
      for (var i1 = 0, len1 = this.filtersFormArray.value.length; i1 < len1; ++i1) {
          var checkColor = [];
          checkColor = this.colorcodeExist.filter(x=>x.colourCode == this.filtersFormArray.value[i1].colourCode)
          if(checkColor.length>0){
            this.toastr.warning('Color already exist,Please choose different color.', '', {
              timeOut: 3000,
            });
            return;
          }
        }
      
    }
    
    if (this.filtersFormArray.length > 0) {
      var relationListModels = [];
      this.dialog.closeAll();
      for (var i = 0, len = this.filtersFormArray.value.length; i < len; ++i) {
        var req = {
          groupRelationParticipantMappingID: 0,
          groupID: this.groupID,
          contactID: null,
          relationID: this.filtersFormArray.value[i].transctionalRoleID,
          relationName: this.filtersFormArray.value[i].transactionalRoleName,
          projectID: this.projectID,
          roleID: null,
          colourCode: this.filtersFormArray.value[i].colourCode,
        }
        relationListModels.push(req)
      }

 
      // for (var i = 0, len = this.dynamicForm.value.filters.length; i < len; ++i) {
      //   var req = {
      //     groupRelationParticipantMappingID: 0,
      //     groupID: this.groupID,
      //     contactID: null,
      //     relationID: this.dynamicForm.value.filters[i].transctionalRoleID,
      //     relationName: this.dynamicForm.value.filters[i].transactionalRoleName,
      //     projectID: this.projectID,
      //     roleID: null,
      //     colourCode: this.dynamicForm.value.filters[i].colourCode,
      //   }
      //   relationListModels.push(req)
      // }

      var ReqModel = {
        relationListModels: relationListModels,
        userID: this.currentUser.UID,
        databaseID: Number(this.databaseId),
        organizationID: Number(this.organizationId),
        type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
        OfficeID:this.myOfficeID
      }
      this.loaderService.show();
      this.formService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            this.transRoleList = [];
            this.dialog.closeAll();
            this.GetGroupList(sessionStorage.getItem('projectID'));
            this.toastr.success('Relation added successfully.', '', {
              timeOut: 3000,
            });
            this.close();            
            this.loaderService.hide();
          }else{
            this.transRoleList = [];
            this.dialog.closeAll();
          }
        }
      });
    } else {
      this.transRoleList = [];
      this.dialog.closeAll();
    }
  }


  userSelectedList: any = [];
  showUserPopup: boolean = false;
  sharedAccessUserList: any=[];
  selectedUser: boolean = false;

  selectSharedAccessRb(value) {
    this.contactemail="";
    //== For Show Contact==//
    if (value == 1) {   
      this.showContact=true;
      this.showRole=false;
      this.showSearchCore=false;
      this.isSharedAccessRolePopup = false;
      this.peoples = [];
      this.selectedsharedAccessRole = [];
      this.sharedAccessUserList=[];
      this.selectCoreList = [];
      this.showAddButton = false;  
      this.selectedUser=false;
      this.showUserPopup=false;
      this.userSelectedList=[];   
      this.isSharedAccessUserPopup=false;
    }
    //== For Show Role==//
    if (value == 2) {
      this.showContact=false;
      this.showRole=true;
      this.showSearchCore=false;
      this.isSharedAccessRolePopup = true;
      this.peoples = [];
      this.selectedsharedAccessRole = [];
      this.sharedAccessUserList=[];
      this.selectCoreList = [];
      this.showAddButton = false;
      this.selectedUser=false;
      this.showUserPopup=false;
      this.userSelectedList=[]; 
      this.isSharedAccessUserPopup=false;
     }  
    //== For Show Core==// 
     if (value == 3) {
      this.showContact=false;
      this.showRole=false;
      this.showSearchCore=true;
      this.isSharedAccessRolePopup = false;
      this.selectCoreList = [];
      this.peoples = [];
      this.selectedsharedAccessRole = [];
      this.sharedAccessUserList=[];
      this.showAddButton = false;
      this.selectedUser=false;
      this.showUserPopup=false;
      this.userSelectedList=[]; 
      this.isSharedAccessUserPopup=false;
    }
    // User
    if (value == 4) {
      this.showContact = false;
      this.showRole = false;
      this.isSharedAccessRolePopup = false;
      this.showSearchCore = false;
      this.showUserPopup=true;
      this.isSharedAccessUserPopup=true;
      this.selectCoreList = [];
      this.sharedAccessUserList=[];
      this.peoples = [];
      this.selectedsharedAccessRole = [];
      this.userSelectedList=[];
      this.showAddButton = false;
    }
  }

  onclickRole(event: any){
    this.filteredContactVm.searchValue = "";
    this.formService.getSharedAccessRoles(this.filteredContactVm).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.sharedAccessRoleList = response.data.filter((m)=>m.roleLevel==0);
        }
        else {
        }
      }
    });
  }

  getSharedAccessRoles(searchValue: any) {
    this.filteredContactVm.searchValue = searchValue;
    this.filteredContactVm.OrganizationID = Number(this.organizationId);
    this.formService.getSharedAccessRoles(this.filteredContactVm).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.sharedAccessRoleList = response.data.filter((m)=>m.roleLevel==0);
        }
      }
    });
  }
   

  getContactListCoreImplementation(searchValue: any) {
    this.searchValues=searchValue;
    this.searchName =searchValue;
    if(searchValue=="") {
      this.peoples=[];
      this.contactsList=[];
      return;      
    }
       
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      UserID: this.currentUser.UID,
      searchValue: searchValue,
      PageSize: 0,
      groupID: this.groupID
    }
    this.formService.GetContactListCoreImplementation(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.contactsList = response.data.contactListModel;
          this.contactsList.forEach(e => {
            e.shortName = e.name.match(/\b(\w)/g).join('');
          });
        }
        // if(searchValue.indexOf('@') !== -1){
        //   // this.contactsList.push(
        //   //   {
        //   //     "contactID":0,
        //   //     "coreID":0,
        //   //     "name":"",
        //   //     "email":"",
        //   //     "imageUrl":"",
        //   //     "isShared":this.isShare,
        //   //     "coreContactUserMapID":0,
        //   //     "trasactionalRoleIds":[],
        //   //     "contactCoreRoleMappingModels":[],
        //   //     "shortName":""
        //   //   })        
        // }
         var newcontact=[]
         newcontact= this.contactsList.filter((x) => x.contactID === 0);
        if(newcontact.length==0){
          if (searchValue.toLowerCase() != searchValue.toLowerCase().match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')
          && searchValue.indexOf('@') == -1){
            this.contactsList.push(
            {
              "contactID":0,
              "coreID":0,
              "name":"Create New",
              "email":"",
              "imageUrl":"",
              "isShared":this.isShare,
              "coreContactUserMapID":0,
              "trasactionalRoleIds":[],
              "contactCoreRoleMappingModels":[],
              "shortName":""
            }
          )
                
           }else{
            //this.showAddButton = true;
           }
          }
        }
              
        
        if(searchValue==""){
          this.peoples=[];
          this.contactsList=[];
        }

        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var check= re.test(String(searchValue).toLowerCase());
        if(check==true){
          this.contactemail =searchValue;
          this.showAddButton = true;
        }
        if(check==false){
          this.contactemail="";
          this.showAddButton = false;
        }       
       }  
    )}
  
    timeout = null;  
    attachedToCoreList: any = [] = [];
    menuModulesList: any = [] = [];
    CorefolderID: number = 0;
    roleIdList: any = [];
    selectCoreList: any = [];
    showSearchCore:boolean=false;
    showContact:boolean=true
    showRole:boolean=false;

    searchCore(val) {
      if (val.length >= 2) {
        this.attachedToCoreList = [];
        if (val != '') {
          this.searchName =val;
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            this.getsearchCore(val)
          }, 500);
        } else {
         this.attachedToCoreList = [];
        }
      }
    }
      

    getsearchCore(searchValue: any) {   
      var SelectedCCC = [];
      SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
      if (SelectedCCC.length > 0) {
        this.CorefolderID = SelectedCCC[0].folderID;
      }
      this.roleIdList = [];
      let roles = sessionStorage.getItem('roleIDList').split(',');
      roles.forEach(e => {
        this.roleIdList.push(Number(e));
      });
    
      var ReqModel = {
        roleIDList: this.roleIdList,
        searchKey: searchValue,
        userContactID: Number(sessionStorage.getItem('userContactID')),
        folderID: this.CorefolderID,
        databaseID: Number(this.databaseId),
        userID: this.currentUser.UID,
        officeID: this.myOfficeID,
        organizationID: Number(this.organizationId),
        officeIDList: this.OfficeIDList
      }
      this.formService.searchCore(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            this.attachedToCoreList = response.data;
            this.attachedToCoreList.push(
              {           
                "coreID":0,
                "name":"Create New",
                "email":"",
                "imageUrl":"",
                "isShared":false,
                "coreContactUserMapID":0,
                "trasactionalRoleIds":[],           
                "shortName":""
              }
            )
            } else {
            this.attachedToCoreList = [];
          }
        }
      })
    }
    
   

  addNew(module){
    this.mainModuleName="Forms";
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module = menuModulesList.filter(x => x.mainModuleName == 'Contact');
    var Modulename= Module[0].orgModuleName;
    this.Module = Modulename;
    this.showAddContact = !this.showAddContact;
  }
  
  contactSelected(contactSelected: any) {
    if(contactSelected.contactID == 0) { 
      this.dialog.closeAll();
      this.addNew('Contact');
      return ;
     }
    if (this.peoples.length > 0) {
      return;
    }
    if(contactSelected.email=="" || contactSelected.email==null || contactSelected.email==undefined){
      this.toastr.warning('Selected '+this.contactNames+' is not added email id.', '', {
        timeOut: 3000,
      });
      return;
    }
    this.peoples.push({
      name: contactSelected.name,
      email: contactSelected.email,
      img: contactSelected.imageUrl,
      contactID: contactSelected.contactID,
      roleID: 0,
      isShared: this.isShare,
      shortName: contactSelected.shortName,
    });
    if (this.peoples.length > 0) {
      this.showAddButton = true;
    }
    else {
      this.showAddButton = false;
    }
  }  
 
  coreSelected(coreSelected: any) {
    if(coreSelected.coreID == 0) { 
      this.dialog.closeAll();
      this.addNew('Core');
      return ;
     }
    if (this.selectCoreList.length > 0) {
      return;
    }
    if(coreSelected.email=="" || coreSelected.email==null || coreSelected.email==undefined){
      this.toastr.warning('Selected '+this.contactNames+' is not added email id.', '', {
        timeOut: 3000,
      });
      return;
    }
    this.stateCtrl.setValue('');
    this.selectCoreList.push({
      name: coreSelected.name,
      email: coreSelected.email,
      img: coreSelected.imageUrl,
      coreID: coreSelected.coreID,
      roleID: 0,
      isShared: this.isShare,
      shortName: coreSelected.shortName,
    });
    if (this.selectCoreList.length > 0) {
      this.showAddButton = true;
    }
    else {
      this.showAddButton = false;
    }
  }  

  onEnter(event) {
   if(event.target.value.toLowerCase() == event.target.value.toLowerCase().match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')){
    this.contactemail = event.target.value;
    var shortname = event.target.value.substring(0,1)
    var req={
      name: "",
      email: this.contactemail,
      img: "",
      contactID: 0,
      roleID: 0,
      isShared: this.isShare,
      shortName: shortname,
      }    
      this.peoples.unshift(req); 
      if (this.peoples.length > 0) {
        this.showAddButton = true;
      }
      else {
        this.showAddButton = false;
      }
      //this.addUpdateParticipants();
    }else{
      if(event.target.value=="Create New"){
        this.dialog.closeAll();
        this.addNew('Contact');
        return ;
      }
      var findContact = this.contactsList.filter((x) => x.name === event.target.value);
      if(findContact.length!=undefined && findContact.length>0){
       let user = this.peoples.find(m=>m.contactID == findContact[0].contactID); 
       if(user == undefined || user=='' || user == null){
         var reqContact={
          name: findContact[0].name,
          email: findContact[0].email,
          img: findContact[0].imageUrl,
          contactID: findContact[0].contactID,
          roleID: 0,
          isShared: this.isShare,
          shortName: findContact[0].shortName,                
          }
          this.peoples.unshift(reqContact); 
          if (this.peoples.length > 0) {
            this.showAddButton = true;
          }
          else {
            this.showAddButton = false;
          }
        } else{
          if (this.peoples.length > 0) {
            this.showAddButton = true;
          }
          else {
            this.showAddButton = false;
          }
        }    
      }
    }

  }
 
  saveAddNewContact(result){
      this.peoples.push({
          name: "",
          email: "",
          img: "",
          contactID: result,
          roleID: 0,
          isShared: this.isShare,
          shortName: "",
        });
        this.addUpdateParticipants();
  }

  makeApprover(event: MatSlideToggleChange,p:any,g:any){
     this.selectedApprover = event.checked;
     this.UpdateRelationButton=true;
    //  let relationListModels = [];
    //  let req = {
    //       groupRelationParticipantMappingID: p.groupRelationParticipantMappingID,
    //       groupID: g.groupID,
    //       relationColour: p.colourCode,
    //       contactID: p.contactID==undefined?0:p.contactID,
    //       relationID: p.relationID,
    //       projectID: sessionStorage.getItem('projectID'),
    //       roleID: null,
    //       contactEmail: p.contactEmail==''?p.participantEmail:p.contactEmail,
    //       isApprover:this.selectedApprover
    //     }
    //     relationListModels.push(req)
      

    //   let ReqModel = {
    //     relationListModels: relationListModels,
    //     userID: this.currentUser.UID,
    //     databaseID: Number(this.databaseId),
    //     organizationID: Number(this.organizationId),
    //     type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
    //     OfficeID:this.myOfficeID
    //   }
    //   this.loaderService.show();
    //   this.formService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
    //     if (response != undefined) {
    //       this.responseHolder = response;
    //       if (this.responseHolder.status == this.statusConstant.statusSuccess) {
    //         //this.dialog.closeAll();             
    //         this.GetGroupList(sessionStorage.getItem('projectID'));
    //         this.toastr.success('Approver status changed successfully.', '', {
    //           timeOut: 3000,
    //         });
    //         this.peoples = [];
    //         this.showAddButton = false;
    //         this.loaderService.hide();             
    //       }
    //     }
    //   });    
    
  }

 
  // addUpdateParticipants() {
  //   this.dialog.closeAll();
  //   if (this.isSharedAccessRolePopup == false) {
  //     if (this.peoples.length > 0) {
  //       var relationListModels = [];
  //       for (var i = 0, len = this.peoples.length; i < len; ++i) {
  //         var req = {
  //           groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
  //           groupID: this.groupID,
  //           relationColour: this.relationColour,
  //           contactID: this.peoples[i].contactID,
  //           relationID: this.relationID,
  //           projectID: sessionStorage.getItem('projectID'),
  //           roleID: null,
  //           contactEmail: this.contactemail
  //         }
  //         relationListModels.push(req)
  //       }

  //       var ReqModel = {
  //         relationListModels: relationListModels,
  //         userID: this.currentUser.UID,
  //         databaseID: Number(this.databaseId),
  //         organizationID: Number(this.organizationId),
  //         type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
  //         OfficeID:this.myOfficeID
  //       }
  //       this.loaderService.show();
  //       this.formService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
  //         if (response != undefined) {
  //           this.responseHolder = response;
  //           if (this.responseHolder.status == this.statusConstant.statusSuccess) {
  //             this.dialog.closeAll();             
  //             this.GetGroupList(sessionStorage.getItem('projectID'));
  //             this.toastr.success('Participant Added successfully.', '', {
  //               timeOut: 3000,
  //             });
  //             this.peoples = [];
  //             this.showAddButton = false;
  //             this.loaderService.hide();             
  //           }
  //         }
  //       });
      
  //     }
  //     else {
  //       this.peoples.push({
  //         groupID: this.groupID,
  //         relationColour: this.relationColour,
  //         contactID: 0,
  //         relationID: this.relationID,
  //         projectID: sessionStorage.getItem('projectID'),
  //         roleID: null,
  //         contactEmail: this.searchName,
  //       });
  //       if (this.peoples.length > 0) {
  //         var relationListModels = [];
  //         for (var i = 0, len = this.peoples.length; i < len; ++i) {
  //           var req = {
  //             groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
  //             groupID: this.groupID,
  //             relationColour: this.relationColour,
  //             contactID: this.peoples[i].contactID,
  //             relationID: this.relationID,
  //             projectID: sessionStorage.getItem('projectID'),
  //             roleID: null,
  //             contactEmail: this.peoples[i].contactEmail//this.contactemail
  //           }
  //           relationListModels.push(req)
  //         }
  
  //         var ReqModelObj = {
  //           relationListModels: relationListModels,
  //           userID: this.currentUser.UID,
  //           databaseID: Number(this.databaseId),
  //           organizationID: Number(this.organizationId),
  //           type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
  //           OfficeID:this.myOfficeID
            
  //         }
  //         this.loaderService.show();
  //         this.formService.AddEditProjectGroupRelationParticipant(ReqModelObj).subscribe(response => {
  //           if (response != undefined) {
  //             this.responseHolder = response;
  //             if (this.responseHolder.status == this.statusConstant.statusSuccess) {
  //               this.dialog.closeAll();             
  //               this.GetGroupList(sessionStorage.getItem('projectID'));
  //               this.toastr.success('Participant Added successfully.', '', {
  //                 timeOut: 3000,
  //               });
  //               this.peoples = [];
  //               this.showAddButton = false;
  //               this.loaderService.hide();             
  //             }
  //           }
  //         });        
  //       }
  //       this.dialog.closeAll();
  //      }
  //     }else {
  //       if (this.selectedsharedAccessRole.length > 0) {
  //         var relationListModels = [];
  //         for (var i = 0, len = this.selectedsharedAccessRole.length; i < len; ++i) {
  //           var req = {
  //             groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
  //             groupID: this.groupID,
  //             relationColour: this.relationColour,
  //             contactID: null,
  //             relationID: this.relationID,
  //             projectID: sessionStorage.getItem('projectID'),
  //             roleID: this.selectedsharedAccessRole[i].roleID,
  //             contactEmail: null
  //           }
  //           relationListModels.push(req)
  //         }
  
  //         var ReqModelObj = {
  //           relationListModels: relationListModels,
  //           userID: this.currentUser.UID,
  //           databaseID: Number(this.databaseId),
  //           organizationID: Number(this.organizationId),
  //           type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
  //           OfficeID:this.myOfficeID
            
  //         }
  //         this.loaderService.show();
  //         this.formService.AddEditProjectGroupRelationParticipant(ReqModelObj).subscribe(response => {
  //           if (response != undefined) {
  //             this.responseHolder = response;
  //             if (this.responseHolder.status == this.statusConstant.statusSuccess) {
  //               this.dialog.closeAll();             
  //               this.GetGroupList(sessionStorage.getItem('projectID'));
  //               this.toastr.success('Participant Added successfully.', '', {
  //                 timeOut: 3000,
  //               });
  //               this.peoples = [];
  //               this.showAddButton = false;
  //               this.loaderService.hide();             
  //             }
  //           }
  //         });        
  //       }
  //     }
  // }


  getShortName(fullName) {
     return fullName.split(' ').map(n => n[0]).join('');
  }

  isSharedAccessUserPopup:boolean=false;

  assignUser(templateRef: TemplateRef<any>, isShare: boolean, isRole: boolean, contact: any, p) {
    this.contactemail="";
    this.groupRelationParticipantMappingID = p.groupRelationParticipantMappingID;
    this.showContact=true;
    this.groupID = p.groupID;
    this.relationColour = p.relationColour;
    this.relationID = p.relationID;
    this.showAddButton = false;

    this.showUserPopup=false;
    this.isSharedAccessUserPopup=false;
    this.userSelectedList=[];
    this.sharedAccessUserList=[];

    this.isShare = isShare;
    this.contactemail = p.contactEmail;
    this.isRolePopup = isRole;
    this.isSharedAccessRolePopup = false;
    this.showSearchCore=false;
    if (isRole)
    this.currentRoleContact = contact;
    this.transRoleList = [];
    this.contactsList = [];
    this.Roles = [];
    this.peoples = [];
    this.selectCoreList=[];
    this.selectedsharedAccessRole = [];
    this.showContactRoleAddButton = false;
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
  }

  assignUserNew(isShare: boolean, isRole: boolean, contact: any, p) {
    this.contactemail="";
    this.groupRelationParticipantMappingID = p.groupRelationParticipantMappingID;
    this.showContact=true;
    this.groupID = p.groupID;
    this.relationColour = p.relationColour;
    this.relationID = p.relationID;
    this.showAddButton = false;

    this.showUserPopup=false;
    this.isSharedAccessUserPopup=false;
    this.userSelectedList=[];
    this.sharedAccessUserList=[];

    this.isShare = isShare;
    this.contactemail = p.contactEmail;
    this.isRolePopup = isRole;
    this.isSharedAccessRolePopup = false;
    this.showSearchCore=false;
    if (isRole)
    this.currentRoleContact = contact;
    this.transRoleList = [];
    this.contactsList = [];
    this.Roles = [];
    this.peoples = [];
    this.selectCoreList=[];
    this.selectedsharedAccessRole = [];
    this.showContactRoleAddButton = false;

    this.addUpdateParticipantList=[];
    this.typeOfParticipant=p.typeOfParticipant;
    this.addEmailButtonShow=false;
    this.emailAssigned="";
    //  // Email =0
    //  if(this.typeOfParticipant==0){
    //   this.addUpdateParticipantList=[];
    //   this.emailAssigned="";
    //   this.ShowEmailBox=true;
    //   this.ShowUserBox=false;
    //   this.ShowRoleBox=false;
    //   this.ShowCoreBox=false;
    //   this.ShowContactBox=false;
    //   this.ShowCompanyBox=false; 

    //   this.textNameShow="Email";
    // }
    // // User=4
    // if(this.typeOfParticipant==4){
    //   this.addUpdateParticipantList=[];
    //   this.emailAssigned="";
    //   this.ShowEmailBox=false;
    //   this.ShowUserBox=true;
    //   this.ShowRoleBox=false;
    //   this.ShowCoreBox=false;
    //   this.ShowContactBox=false;
    //   this.ShowCompanyBox=false; 

    //   this.textNameShow="User";
    // }
    // // Role=5
    // if(this.typeOfParticipant==5){
    //   this.addUpdateParticipantList=[];
    //   this.emailAssigned="";
    //   this.ShowEmailBox=false;
    //   this.ShowUserBox=false;
    //   this.ShowRoleBox=true;
    //   this.ShowCoreBox=false;
    //   this.ShowContactBox=false;
    //   this.ShowCompanyBox=false; 

    //   this.textNameShow="Role";
    // }
    //  // Core=1
    //  if(this.typeOfParticipant==1){
    //   this.addUpdateParticipantList=[];
    //   this.emailAssigned="";
    //   this.ShowEmailBox=false;
    //   this.ShowUserBox=false;
    //   this.ShowRoleBox=false;
    //   this.ShowCoreBox=true;
    //   this.ShowContactBox=false;
    //   this.ShowCompanyBox=false; 

    //   this.textNameShow=this.CoreShowName;
    // }
    //  // Contact=2
    //  if(this.typeOfParticipant==2){
    //   this.addUpdateParticipantList=[];
    //   this.emailAssigned="";
    //   this.ShowEmailBox=false;
    //   this.ShowUserBox=false;
    //   this.ShowRoleBox=false;
    //   this.ShowCoreBox=false;
    //   this.ShowContactBox=true;
    //   this.ShowCompanyBox=false; 

    //   this.textNameShow=this.ContactShowName;
    // }
    //  // Company=3
    //  if(this.typeOfParticipant==3){
    //   this.addUpdateParticipantList=[];
    //   this.emailAssigned="";
    //   this.ShowEmailBox=false;
    //   this.ShowUserBox=false;
    //   this.ShowRoleBox=false;
    //   this.ShowCoreBox=false;
    //   this.ShowContactBox=false;
    //   this.ShowCompanyBox=true; 

    //   this.textNameShow=this.CompanyShowName;
    // }

    const dialogRef = this.dialog.open(Add3ctypeformComponent, {     
      data: {
        moduleName:"Step2",
        typeOfParticipant:this.typeOfParticipant   
      },
      panelClass: 'signatureModal',
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=null && result!=undefined){
        this.addUpdateParticipantsNew(result);
      }      
    });
  }

  addUpdateParticipantsNew(result){
    this.dialog.closeAll();
    this.peoples =[];
    this.peoples = result;

    //=== For Email ======//
    if (result[0].typeOfParticipant==0) {
        if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var req = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID:0,
            contactID: 0,
            companyID:0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID:0,
            relationID: this.relationID,
            relationColour: this.relationColour,           
            projectID: sessionStorage.getItem('projectID'),
            emailFieldID:0,
            nameFieldID:0,
            roleID: 0,    
            userID:0,        
            typeOfParticipant:0//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(req)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
          OfficeID:this.myOfficeID
        }
        this.loaderService.show();
        this.formService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.dialog.closeAll();             
              this.GetGroupList(sessionStorage.getItem('projectID'));
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();             
            }
          }
        });      
      }     
    }

    //=== For User ======//
    if (result[0].typeOfParticipant==4) {
        if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqUser = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID:0,
            contactID: 0,
            companyID:0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID:0,
            relationID: this.relationID,
            relationColour: this.relationColour,           
            projectID: sessionStorage.getItem('projectID'),
            emailFieldID:0,
            nameFieldID:0,
            roleID: 0,    
            userID:this.peoples[i].userID,        
            typeOfParticipant:4,
          }
          relationListModels.push(reqUser)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
          OfficeID:this.myOfficeID
        }
        this.loaderService.show();
        this.formService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.dialog.closeAll();             
              this.GetGroupList(sessionStorage.getItem('projectID'));
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();             
            }
          }
        });      
      }     
    }

     //=== For Role ======//
     if (result[0].typeOfParticipant==5) {
      if (this.peoples.length > 0) {
      var relationListModels = [];
      for (var i = 0, len = this.peoples.length; i < len; ++i) {
        var reqRole = {
          groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
          groupID: this.groupID,
          coreID:0,
          contactID: 0,
          companyID:0,
          contactEmail: null,
          selectedContactFieldEmailID:0,
          relationID: this.relationID,
          relationColour: this.relationColour,           
          projectID: sessionStorage.getItem('projectID'),
          emailFieldID:0,
          nameFieldID:0,
          roleID: this.peoples[i].roleID, 
          userID:0,           
          typeOfParticipant:5//this.peoples[i].typeOfParticipant,
        }
        relationListModels.push(reqRole)
      }

      var ReqModel = {
        relationListModels: relationListModels,
        userID: this.currentUser.UID,
        databaseID: Number(this.databaseId),
        organizationID: Number(this.organizationId),
        type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
        OfficeID:this.myOfficeID
      }
      this.loaderService.show();
      this.formService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            this.dialog.closeAll();             
            this.GetGroupList(sessionStorage.getItem('projectID'));
            this.toastr.success('Participant Added successfully.', '', {
              timeOut: 3000,
            });
            this.peoples = [];
            this.showAddButton = false;
            this.loaderService.hide();             
          }
        }
      });      
    }     
     }

      //=== For Core ======//
     if (result[0].typeOfParticipant==1) {
        if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqCore = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: this.peoples[i].coreID,
            contactID: 0,
            companyID:0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID:0,
            relationID: this.relationID,
            relationColour: this.relationColour,           
            projectID: sessionStorage.getItem('projectID'),
            emailFieldID:0,
            nameFieldID:0,
            roleID: 0,     
            userID:0,         
            typeOfParticipant:1//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqCore)
        }
  
        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
          OfficeID:this.myOfficeID
        }
        this.loaderService.show();
        this.formService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.dialog.closeAll();             
              this.GetGroupList(sessionStorage.getItem('projectID'));
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();             
            }
          }
        });      
      }     
     }

      //=== For Contact ======//
     if (result[0].typeOfParticipant==2) {
        if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqContact = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: this.peoples[i].contactID,
            companyID:0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID:0,
            relationID: this.relationID,
            relationColour: this.relationColour,           
            projectID: sessionStorage.getItem('projectID'),
            emailFieldID:0,
            nameFieldID:0,
            roleID: 0,    
            userID:0,          
            typeOfParticipant:2//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqContact)
        }
  
        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
          OfficeID:this.myOfficeID
        }
        this.loaderService.show();
        this.formService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.dialog.closeAll();             
              this.GetGroupList(sessionStorage.getItem('projectID'));
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();             
            }
          }
        });      
      }     
     }

      //=== For Company ======//
      if (result[0].typeOfParticipant==3) {
        if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqCompany= {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: 0,
            companyID:this.peoples[i].companyID,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID:0,
            relationID: this.relationID,
            relationColour: this.relationColour,           
            projectID: sessionStorage.getItem('projectID'),
            emailFieldID:0,
            nameFieldID:0,
            roleID: 0,      
            userID:0,        
            typeOfParticipant:3//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqCompany)
        }
  
        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
          OfficeID:this.myOfficeID
        }
        this.loaderService.show();
        this.formService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.dialog.closeAll();             
              this.GetGroupList(sessionStorage.getItem('projectID'));
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();             
            }
          }
        });      
      }     
     }
   }


addUpdateParticipants() {
    this.dialog.closeAll();
    if (this.showContact == true) {
      if(this.contactemail!=""){
        var shortname = this.contactemail.substring(0,1)
        var req1={
          name: "",
          email: this.contactemail,
          img: "",
          contactID: 0,
          roleID: 0,
          isShared: this.isShare,
          shortName: shortname,
          }    
          this.peoples.unshift(req1); 
      }
      if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var req = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            relationColour: this.relationColour,
            contactID: this.peoples[i].contactID,
            relationID: this.relationID,
            projectID: sessionStorage.getItem('projectID'),
            roleID: null,
            contactEmail: this.contactemail
          }
          relationListModels.push(req)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
          OfficeID:this.myOfficeID
        }
        this.loaderService.show();
        this.formService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.dialog.closeAll();             
              this.GetGroupList(sessionStorage.getItem('projectID'));
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();             
            }
          }
        });      
      }     
     }
    if(this.showRole == true) {
      if (this.selectedsharedAccessRole.length > 0) {
          var relationListModels = [];
          for (var i = 0, len = this.selectedsharedAccessRole.length; i < len; ++i) {
            var req = {
              groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
              groupID: this.groupID,
              relationColour: this.relationColour,
              contactID: null,
              relationID: this.relationID,
              projectID: sessionStorage.getItem('projectID'),
              roleID: this.selectedsharedAccessRole[i].roleID,
              contactEmail: null
            }
            relationListModels.push(req)
          }
  
          var ReqModelObj = {
            relationListModels: relationListModels,
            userID: this.currentUser.UID,
            databaseID: Number(this.databaseId),
            organizationID: Number(this.organizationId),
            type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
            OfficeID:this.myOfficeID
            
          }
          this.loaderService.show();
          this.formService.AddEditProjectGroupRelationParticipant(ReqModelObj).subscribe(response => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConstant.statusSuccess) {
                this.dialog.closeAll();             
                this.GetGroupList(sessionStorage.getItem('projectID'));
                this.toastr.success('Participant Added successfully.', '', {
                  timeOut: 3000,
                });
                this.peoples = [];
                this.showAddButton = false;
                this.loaderService.hide();             
              }
            }
          });        
       }
     }
     if(this.showSearchCore == true) {
      if (this.selectCoreList.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.selectCoreList.length; i < len; ++i) {
          var reqCore = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            relationColour: this.relationColour,
            coreID: this.selectCoreList[i].coreID,
            relationID: this.relationID,
            projectID: sessionStorage.getItem('projectID'),
            roleID: null,
            contactEmail: this.contactemail
          }
          relationListModels.push(reqCore)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
          OfficeID:this.myOfficeID
        }
        this.loaderService.show();
        this.formService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.dialog.closeAll();             
              this.GetGroupList(sessionStorage.getItem('projectID'));
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();             
            }
          }
        });      
       }     
     }
     if (this.isSharedAccessUserPopup == true) {  
     
      if (this.userSelectedList.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.userSelectedList.length; i < len; ++i) {
          var req11 = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            relationColour: this.relationColour,
            contactID: 0,
            relationID: this.relationID,
            projectID: sessionStorage.getItem('projectID'),
            roleID: null,
            contactEmail: this.userSelectedList[i].email,
          }
          relationListModels.push(req11)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
          OfficeID:this.myOfficeID
        }
        this.loaderService.show();
        this.formService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.dialog.closeAll();             
              this.GetGroupList(sessionStorage.getItem('projectID'));
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();             
            }
          }
        });      
      }     
     }
  }

  // Remove Group Relation 
  RemoveGroupRelation(group) {
    const message = `Are you sure you want to delete this group participant ?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          if (group !== undefined) {
            var ReqModel = {
              groupRelationParticipantMappingID: group.groupRelationParticipantMappingID,
              userID: this.currentUser.UID,
              databaseID: Number(this.databaseId),
              organizationID: Number(this.organizationId),
              type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
            }
            this.formService.RemoveGroupRelation(ReqModel).subscribe((response) => {
              if (response != undefined) {
                this.responseHolder = response;
                if (this.responseHolder.status == this.statusConstant.statusSuccess) {
                  this.loaderService.hide();
                  this.GetGroupList(sessionStorage.getItem('projectID'));
                  this.toastr.success('Group participant remove successfully.', '', {
                    timeOut: 3000,
                  });
                }               
              } else {
                this.loaderService.hide();
              }
            });
          }
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }


  // Remove Relation 
  RemoveRelation(group) {
    const message = `Are you sure you want to delete this participant?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          if (group !== undefined) {

            var relationListModels = [];
            var req = {
              groupRelationParticipantMappingID: group.groupRelationParticipantMappingID,
              groupID: group.groupID,
              relationColour: group.relationColour,
              contactID: null,
              relationID: group.relationID,
              projectID: sessionStorage.getItem('projectID'),
              roleID: null,
              typeOfParticipant:group.typeOfParticipant
            }
            relationListModels.push(req)

            var ReqModel = {
              relationListModels: relationListModels,
              userID: this.currentUser.UID,
              databaseID: Number(this.databaseId),
              organizationID: Number(this.organizationId),
              type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
              OfficeID:this.myOfficeID
            }
            this.formService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe((response) => {
              if (response != undefined) {
                this.responseHolder = response;
                if (this.responseHolder.status == this.statusConstant.statusSuccess) {
                  this.loaderService.hide();
                  this.GetGroupList(sessionStorage.getItem('projectID'));
                  this.toastr.success('Participant removed successfully', '', {
                    timeOut: 3000,
                  });
                }
              } else {
                this.loaderService.hide();
              }
            });
          }
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }


  OpenProjectGroupDialog(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
    this.addGroupNameForm.reset();
  }

  close() {
    this.selectCoreList=[];
    this.Roles = [];
    this.contactsList = [];
    this.selectedsharedAccessRole = [];
    this.peoples = [];
    this.colorcodeExist = [];
    this.showContactRoleAddButton = false;
    this.UpdateRelationButton=false;
    this.addGroupNameForm.reset();
    this.UpdateRelationColorButton = false;
    this.updateRelationColorForm.reset();
    this.checkDuplicateColor=[];
    this.RelationNameList=[];
    this.dialog.closeAll();
  }

  SubmitBackButton() {
    if (sessionStorage.getItem('ProjectName') == null || sessionStorage.getItem('ProjectName') == undefined || sessionStorage.getItem('ProjectName') == '') {
      this.toastr.warning('Please enter project name.');
      return;
    }
    this._dataSharingService.sendProjectNameAlreadyExist(false);

    let ReqModel = {
      ProjectName:sessionStorage.getItem('ProjectName'),
      projectID: Number(sessionStorage.getItem('projectID')),
      userID: this.currentUser.UID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
    }
     this.loaderService.show();
     this.formService.AddProjectStepSecond(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.router.navigate(['/esignature/first']);
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      }
    });
  }
  
  projGrpRelationParticipant:boolean=true;

  SubmitNextButton() {
    if (sessionStorage.getItem('ProjectName') == null || sessionStorage.getItem('ProjectName') == undefined || sessionStorage.getItem('ProjectName') == '') {
      this.toastr.warning('Please enter project name.');
      return;
    }
    this.SubmitNextButtonDisabled=false;
    if(Number(sessionStorage.getItem('stepCompleted'))<2){
      sessionStorage.setItem('stepCompleted','2');
    }

    var checkGroup:any=[]=[];
    var checkGroupRecord:any=[]=[];   
    var checkGroupValidation:any=[]=[];     
    this.projGrpRelationParticipant=true;
    var checkGroup = this.projectGroups.filter(m => m.groupType == 1);
    if(checkGroup.length>0){
     for (var i = 0, len4 = checkGroup.length; i < len4; ++i) {
       var projGrpRelationParticipantList = [];
       projGrpRelationParticipantList = checkGroup[i].projGrpRelationParticipantList;
       if(projGrpRelationParticipantList.length>0){
        var obj={
          isParticipant:true
        }
        checkGroupRecord.push(obj)
       }else{
        var obj={
          isParticipant:false
        }
        checkGroupRecord.push(obj)
       }
      } 
      checkGroupValidation=checkGroupRecord.filter(x=>x.isParticipant==true);
      if(checkGroupValidation.length==0){
        this.toastr.warning('Please add atleast 1 relation in groups.');
        return;
      }   
    }

   
    let ReqModel = {
      ProjectName:sessionStorage.getItem('ProjectName'),
      projectID: Number(sessionStorage.getItem('projectID')),
      userID: this.currentUser.UID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
    }
     this.loaderService.show();
     this.formService.AddProjectStepSecond(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;       
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {        
         setTimeout(() => {
          this.router.navigate(['/esignature/third']);
          this.loaderService.hide();
        },3000);        
        } else {
          this.SubmitNextButtonDisabled=true;
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
        this.SubmitNextButtonDisabled=true;
      }
    });
   }


  drop(event: CdkDragDrop<string[]>, groupID) {
    var groupRelationParticipantMappingFromIDList = [];
    var groupRelationParticipantMappingToIDList = [];
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      let FromList: any = [];
      FromList = event.container.data;

      if (FromList.length > 0) {
        for (var i = 0, len = FromList.length; i < len; ++i) {
          var req = {
            groupID: groupID,
            groupRelationParticipantMappingID: FromList[i].groupRelationParticipantMappingID,
          }
          groupRelationParticipantMappingFromIDList.push(req)
        }
      }

      this.ReorderGroupRelations(groupRelationParticipantMappingFromIDList,groupRelationParticipantMappingToIDList)

    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);

      let ToList: any = [];
      ToList = event.container.data;

      if (ToList.length > 0) {
        for (var i = 0, len = ToList.length; i < len; ++i) {
          var req = {
            groupID: groupID,
            groupRelationParticipantMappingID: ToList[i].groupRelationParticipantMappingID,
          }
          groupRelationParticipantMappingToIDList.push(req)
        }
      }
      this.ReorderGroupRelations(groupRelationParticipantMappingFromIDList,groupRelationParticipantMappingToIDList)
    }
  }

  ReorderGroupRelations(FromIDList, ToIDList) {
    var ReqModel = {
      groupRelationParticipantMappingFromIDList: FromIDList,
      groupRelationParticipantMappingToIDList: ToIDList,
      projectID: sessionStorage.getItem('projectID'),
      userID: this.currentUser.UID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
    }
    this.formService.ReorderFormGroupRelations(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();
          this.GetGroupList(sessionStorage.getItem('projectID'));
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  onChangeColourCode(event, role) {
     this.Roles;
     this.dynamicForm.value.filters = this.Roles;

     var new1 = this.dynamicForm.value.filters;
     var check = this.dynamicForm.value.filters.filter((s) => s.colourCode == event.value);
     //var check1 = this.dynamicForm.value.filters.filter((s) => s.colourCode == event.value);
     if(check.length > 0 ){     
      this.toastr.warning('selected color allready used.', '', {
        timeOut: 3000,
      });

      //this.Roles.find((item) => item.transactionalRoleName == role).colourCode = event.value;

      this.dynamicForm = this.formBuilder.group({
        filters: this.formBuilder.array([]),      
      });
     
      new1.forEach(seedDatum => {
        const formGroup = this.createFilterGroup();
        if (seedDatum.transactionalRoleName) {
          formGroup.addControl('value', this.getFormControl());
        }
        formGroup.patchValue(seedDatum);
        this.filtersFormArray.push(formGroup);
      });

      //this.Roles.find((item) => item.transactionalRoleName == role).colourCode = event.value;
      return;
    }
    else
    {
      if(this.filtersFormArray.controls.length>0 && this.filtersFormArray.controls.find(n=>n.value.transactionalRoleName==role)!=undefined)
      {
        if(this.filtersFormArray.controls.find(n=>n.value.transactionalRoleName==role).value!=undefined)
        {
          this.filtersFormArray.controls.find(n=>n.value.transactionalRoleName==role).value.colourCode= event.value;
        }
      }
    }


    // this.Roles;
    // this.Roles.find((item) => item.transctionalRoleID == role.transctionalRoleID
    //   && item.transactionalRoleName == role.transactionalRoleName).colourCode = event.value;
    //  if (this.Roles.length > 0) {
    //   var obj = {
    //     colourCode: event.value,
    //     transctionalRoleID: role.transctionalRoleID,
    //   }
      // this.colorcodeExist.push(obj);
      // var data = [];
      // data = this.Roles.filter((e) => e.colourCode == '');
      // if (data.length > 0) {
      //   this.showContactRoleAddButton = false;
      // }
      // else {
      //   this.showContactRoleAddButton = true;
      // }
    //}
    // if(this.colorcodeExist.length > 0){  

    //   let _notExistColor = this.colourCode.filter(({ colourCode: id1 }) => !this.colorcodeExist.some(({ colourCode: id2 }) => id2 === id1));
    //   this.colourCode = _notExistColor.map(s => Object.assign(s));    
    //  }
    //this.cdr.detectChanges();
  }

  onChangeColourCodeupdate(event) {
    this.selectedcolorOnUpdate = event.value;
    this.UpdateRelationColorButton = true;
  }

 
  updateRelationColor(templateRef: TemplateRef<any>, group) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
    this.updateRelationColorForm.reset();
    this.participantID = group.groupRelationParticipantMappingID;
    this.selectedcolorOnUpdate=group.colourCode;
    this.UpdateRelationColorButton=false;
    this.groupID = group.groupID;
    this.groupType = group.groupType;
    this.projectID = group.projectID;
    this.transactionalRoleName = group.relationName;
    this.relationID = group.relationID;
    this.ContactIdforUpdateColor=group.contactID;
    this.groupRelationParticipantMappingID = group.groupRelationParticipantMappingID;    
    var colorcodes = this.ShowcolourCode;
    let _notExistColor = colorcodes.filter(({ colourCode: id1 }) => !this.colorcodeExist.some(({ colourCode: id2 }) => id2 === id1));
    this.colourCode = _notExistColor.map(s => Object.assign(s));
  }

  participantID:number=0;


  UpdateRelationColor(formvalue) {
     if(this.projectGroups.length>0){
      var projGrpRelationParticipantList:any=[]=[];
     // 👉 Extract all participants into another list
      projGrpRelationParticipantList = this.projectGroups
     .map(g => g.projGrpRelationParticipantList || []) // collect each group's participants
     .flat(); // flatten into a single array
    }
    // 👉 Check for colourCode
    const participantWithColor = projGrpRelationParticipantList.find(
     (p: any) => p.colorCode === formvalue.colourCode);

     // If found, show toaster
     if (participantWithColor){
      this.toastr.warning('Color already added.Please choose a different one.', '', {
        timeOut: 3000,
       });
       return;
     }

    if (formvalue != undefined) { 
      this.dialog.closeAll();     
      var ReqModel = {
        participantID:this.participantID,
        type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
        color:formvalue.colourCode,       
        userID: this.currentUser.UID,
        databaseID: Number(this.databaseId),
        organizationID: Number(this.organizationId),        
        OfficeID:this.myOfficeID
      }
      this.loaderService.show();
      this.formService.changeParticipantColor(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            this.dialog.closeAll();
            this.UpdateRelationColorButton=false;
            this.GetGroupList(sessionStorage.getItem('projectID'));
            this.toastr.success('Participant color update successfully.', '', {
              timeOut: 3000,
            });
            this.loaderService.hide();
          }else{
            this.dialog.closeAll();
            this.UpdateRelationColorButton=false;
            this.GetGroupList(sessionStorage.getItem('projectID'));
            this.loaderService.hide();
          }
        }
      });
    } else {
      this.dialog.closeAll();
      this.loaderService.hide();
    }
  }


  // UpdateRelationColor(formvalue) {
  //   if (formvalue != undefined) {
  //     var relationListModels = [];
  //     this.dialog.closeAll();
  //     var req = {
  //       groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
  //       groupID: this.groupID,
  //       contactID: this.ContactIdforUpdateColor,
  //       relationID: this.relationID,
  //       relationName: this.transactionalRoleName,
  //       projectID: (sessionStorage.getItem('projectID')),
  //       roleID: null,
  //       colourCode: formvalue.colourCode
  //     }
  //     relationListModels.push(req);
  //     var ReqModel = {
  //       relationListModels: relationListModels,
  //       userID: this.currentUser.UID,
  //       databaseID: Number(this.databaseId),
  //       organizationID: Number(this.organizationId),
  //       type:Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
  //       OfficeID:this.myOfficeID
  //     }
  //     this.loaderService.show();
  //     this.formService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
  //       if (response != undefined) {
  //         this.responseHolder = response;
  //         if (this.responseHolder.status == this.statusConstant.statusSuccess) {
  //           this.dialog.closeAll();
  //           this.UpdateRelationColorButton=false;
  //           this.GetGroupList(sessionStorage.getItem('projectID'));
  //           this.toastr.success('Participant color update successfully.', '', {
  //             timeOut: 3000,
  //           });
  //           this.loaderService.hide();
  //         }
  //       }
  //     });
  //   } else {
  //     this.dialog.closeAll();
  //     this.loaderService.hide();
  //   }
  // }

  

  // ==  Update Relation Name == // 
  
  
  relationName:string="";
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  roleInputCurrentvalue:any;
  stateCtrSendlValue: any;
  objectList:any=[];
  RelationNameList:any=[]=[];
  UpdateRelationButton:boolean=false;
  spinner:boolean=false;
  participantEmailForUpdate:string="";

  updateRelationName(templateRef: TemplateRef<any>, group,participant:any) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });    
    this.addUpdateParticipantList=[];
    this.participantEmailForUpdate =group.participantEmail; 
    this.typeOfParticipant=group.typeOfParticipant;
    this.addEmailButtonShow=false;
    this.emailAssigned="";
    
    this.UpdateRelationButton=false;
    this.stateCtrl.setValue('');
    this.RelationNameList=[];
    this.groupID = group.groupID;
    this.groupType = group.groupType;
    this.projectID = group.projectID;
    this.selectedApprover=group.isApprover;
    this.selectedGroup=participant;
    this.selectedParticipant=group;
    this.transactionalRoleName = group.relationName;
    this.relationID = group.relationID;
    this.relationName = group.relationName;
    this.groupRelationParticipantMappingID = group.groupRelationParticipantMappingID;   

    this.RelationNameList=[];

    this.RelationNameList.push({
      transactionalRoleName: group.relationName,
      transctionalRoleID: group.relationID,     
    });
    this.getTypeOfParticipants();

  }

  typeofParticipantList:any=[]=[];

  getTypeOfParticipants() {
    var objReqModel={
      userID: this.currentUser.UID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      officeID:this.myOfficeID,
    }
    this.formService.getTypeOfParticipant(objReqModel).subscribe(response => {
      if (response !== undefined) {       
        this.responseHolder = response;
        if (this.responseHolder.status === this.statusConstant.statusSuccess) {
          this.typeofParticipantList= this.responseHolder.data;   
          if(this.typeofParticipantList.length>0){
            this.typeofParticipantList.map((res) => {
              if (res.value==0) {
                res.icon="email";
              }
              if (res.value==1) {
                res.icon="app_registration";
              }
              if (res.value==2) {
                res.icon="contact_mail";
              }
              if (res.value==3) {
                res.icon="business";
              }
              if (res.value==4) {
                res.icon="person";
              }
              if (res.value==5) {
                res.icon="work";
              }
            });
          }        
          this.showTypeofParticipant()      
        } else {
          this.typeofParticipantList=[];
        }
      } else {
        this.typeofParticipantList=[];      
      }
    });
  }

  showTypeofParticipant(){
      // Email =0
      if(this.typeOfParticipant==0){
        this.addUpdateParticipantList=[];
        this.emailAssigned="";
        this.ShowEmailBox=true;
        this.ShowUserBox=false;
        this.ShowRoleBox=false;
        this.ShowCoreBox=false;
        this.ShowContactBox=false;
        this.ShowCompanyBox=false; 
  
        this.textNameShow="Email";
      }
      // User=4
      if(this.typeOfParticipant==4){
        this.addUpdateParticipantList=[];
        this.emailAssigned="";
        this.ShowEmailBox=false;
        this.ShowUserBox=true;
        this.ShowRoleBox=false;
        this.ShowCoreBox=false;
        this.ShowContactBox=false;
        this.ShowCompanyBox=false; 
  
        this.textNameShow="User";
      }
      // Role=5
      if(this.typeOfParticipant==5){
        this.addUpdateParticipantList=[];
        this.emailAssigned="";
        this.ShowEmailBox=false;
        this.ShowUserBox=false;
        this.ShowRoleBox=true;
        this.ShowCoreBox=false;
        this.ShowContactBox=false;
        this.ShowCompanyBox=false; 
  
        this.textNameShow="Role";
      }
       // Core=1
       if(this.typeOfParticipant==1){
        this.addUpdateParticipantList=[];
        this.emailAssigned="";
        this.ShowEmailBox=false;
        this.ShowUserBox=false;
        this.ShowRoleBox=false;
        this.ShowCoreBox=true;
        this.ShowContactBox=false;
        this.ShowCompanyBox=false; 
  
        this.textNameShow=this.CoreShowName;
      }
       // Contact=2
       if(this.typeOfParticipant==2){
        this.addUpdateParticipantList=[];
        this.emailAssigned="";
        this.ShowEmailBox=false;
        this.ShowUserBox=false;
        this.ShowRoleBox=false;
        this.ShowCoreBox=false;
        this.ShowContactBox=true;
        this.ShowCompanyBox=false; 
  
        this.textNameShow=this.ContactShowName;
      }
       // Company=3
       if(this.typeOfParticipant==3){
        this.addUpdateParticipantList=[];
        this.emailAssigned="";
        this.ShowEmailBox=false;
        this.ShowUserBox=false;
        this.ShowRoleBox=false;
        this.ShowCoreBox=false;
        this.ShowContactBox=false;
        this.ShowCompanyBox=true; 
  
        this.textNameShow=this.CompanyShowName;
      }
  }

  RelationNameSelected(relation) {
    this.relationID;
    this.stateCtrl.setValue('');
    // if(this.RelationNameList.length>0){
    //   // this.toastr.warning('Select only 1 relation name.', '', {
    //   //   timeOut: 3000,
    //   // });
    //   return;
    // }
    if(this.relationID == relation.transctionalRoleID) {
      this.toastr.warning('Can not update with same relation name.', '', {
        timeOut: 3000,
      });
      return;
    }
    // if(relation.transctionalRoleID==0){
    //   this.toastr.warning('Can not add new relation name.', '', {
    //     timeOut: 3000,
    //   });
    //   return;
    // }
    this.RelationNameList=[];
    this.RelationNameList.push({
      transactionalRoleName: relation.transactionalRoleName,
      transctionalRoleID: relation.transctionalRoleID,     
    });

    if (this.RelationNameList.length > 0) {
      this.UpdateRelationButton = true;
    }
    else {
      this.UpdateRelationButton = false;
    }        
  }

  removeRelationName(item: any) {
    const index = this.RelationNameList.indexOf(item);
    if (index >= 0) {
        this.RelationNameList.splice(index, 1);
     }    
    if (this.RelationNameList.length == 0) {
      this.UpdateRelationButton = false;
    }  
  }

 

  UpdateRelations() {
    if(this.typeOfParticipant==0){
      if(this.participantEmailForUpdate==null){
        this.participantEmailForUpdate='';
      }
    }else{
      this.participantEmailForUpdate='';
    }
   
    var ReqModel = {
      groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
      transctionalRoleID: this.RelationNameList[0].transctionalRoleID,
      relationName : this.RelationNameList[0].transactionalRoleName,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      typeOfParticipant:Number(this.typeOfParticipant),
      type: Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
      email:this.participantEmailForUpdate,
      isApprover:this.selectedApprover
    }
    // return;
    this.spinner=true;
    this.UpdateRelationButton=false;
    this.loaderService.show();
    this.formService.updateProjectGroupRelationName(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.spinner=false;
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {         
          this.RelationNameList = [];
          this.dialog.closeAll();
          this.GetGroupList(sessionStorage.getItem('projectID'));
          this.toastr.success('Relation update successfully.', '', {
            timeOut: 3000,
          });
          this.close();
          this.loaderService.hide();
        }else{
          this.spinner=false;
          this.RelationNameList = [];
          this.loaderService.hide();
          this.dialog.closeAll();
        }
      }else{
        this.spinner=false;
        this.RelationNameList = [];
        this.loaderService.hide();
        this.dialog.closeAll();
      }
    });
  }


  states= this.objectList;

  getClose(message){
    this.showAddContact = message;
  }


  searchUser(val) {
    if (val.length >= 2) {
      this.sharedAccessUserList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getUserListCoreImplementation(val)
        }, 500);
      } else {
        this.sharedAccessUserList = [];
      }
    }
  }
  
  getUserListCoreImplementation(searchValue: any) {
    if (searchValue == "" || searchValue == null || searchValue == undefined) {
      this.sharedAccessUserList = [];
      return;
    }
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      officeID:this.myOfficeID,
      searchKey: searchValue.trim(),
      PageSize: 0,
      pageIndex: 0,
      UserID: this.currentUser.UID
    }
    this.formService.GetUserList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.sharedAccessUserList = response.data.userModel;
          this.sharedAccessUserList.map((res) => {
            if (res.email != null) {
              res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
            }
            if (res.firstName != null) {
              res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
            }
            if (res.lastName != null) {
              res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
            }
            return res;
          });
          this.sharedAccessUserList = this.sharedAccessUserList;
        }
      }
    });
  }


  userSelected(userSelected: any) {
    var user=[];
    user = this.userSelectedList.filter(m => m.userID == userSelected.userID);
    if (user.length==0) {   
      var shortName = userSelected.firstName.match(/\b(\w)/g).join('');
      this.userSelectedList.push({
         name: userSelected.firstName + " " + userSelected.lastName,      
         email: userSelected.email,        
         userID: userSelected.userID,      
         img: "",
         shortName:shortName,       
      });    
    }else{
      this.toastr.warning('User allready added.', '', {
        timeOut: 3000,
      });
    }
    if(this.userSelectedList.length > 0){
      this.showAddButton=true;
    }
    else{
      this.showAddButton=false;
    } 
  }

  removeUser(item: any) {
    const index = this.userSelectedList.indexOf(item);
    if (index >= 0) {
      this.userSelectedList.splice(index, 1);   
    }
    if(this.userSelectedList.length == 0){
      this.showAddButton =false;
    }
  }


   //======================Company============================//

   searchCompany(val) {
    if (val.length >= 2) {
      this.CompanyList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchCompany(val)
        }, 500);
      } else {
        this.CompanyList = [];
      }
    }
  }

  getsearchCompany(searchValue: any) {
    var SelectedCCC = [];

    SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Company');
    if (SelectedCCC.length > 0) {
      this.CompanyfolderID = SelectedCCC[0].folderID;
    }

    this.roleIdList = [];

    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CompanyfolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.formService.searchCompany(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.CompanyList = response.data;
        } else {
          this.CompanyList = [];
        }
      }
    })
  }

  ///========== Type of particpant ==============//

  CoreShowName: string = '';
  ContactShowName: string = '';
  CompanyShowName: string = '';
  typeOfParticipant:number=0;
  emailAssigned: string = '';
  addEmailButtonShow: boolean = false;
  addUpdateParticipantList:any=[]=[];
  ShowEmailBox: boolean = false;
  ShowUserBox: boolean = false;
  ShowRoleBox: boolean = false;
  ShowCoreBox: boolean = false;
  ShowContactBox: boolean = false;
  ShowCompanyBox: boolean = false;
  CompanyList:any=[]=[];
  CompanyfolderID:number=0;

  onSelectParticpant(typeOfParticipant) {
    this.stateCtrl.setValue('');
    this.typeOfParticipant = typeOfParticipant.value;
    this.UpdateRelationButton = true;
    //== For Email =0, Core=1, Contact=1, Company=3, User=4, Role=5 ==//

     // Email =0
    if(this.typeOfParticipant==0){
      this.addUpdateParticipantList=[];
      this.emailAssigned="";
      this.ShowEmailBox=true;
      this.ShowUserBox=false;
      this.ShowRoleBox=false;
      this.ShowCoreBox=false;
      this.ShowContactBox=false;
      this.ShowCompanyBox=false; 

      this.textNameShow="Email";
    }
    // User=4
    if(this.typeOfParticipant==4){
      this.addUpdateParticipantList=[];
      this.emailAssigned="";
      this.ShowEmailBox=false;
      this.ShowUserBox=true;
      this.ShowRoleBox=false;
      this.ShowCoreBox=false;
      this.ShowContactBox=false;
      this.ShowCompanyBox=false; 

      this.textNameShow="User";
    }
    // Role=5
    if(this.typeOfParticipant==5){
      this.addUpdateParticipantList=[];
      this.emailAssigned="";
      this.ShowEmailBox=false;
      this.ShowUserBox=false;
      this.ShowRoleBox=true;
      this.ShowCoreBox=false;
      this.ShowContactBox=false;
      this.ShowCompanyBox=false; 

      this.textNameShow="Role";
    }
     // Core=1
     if(this.typeOfParticipant==1){
      this.addUpdateParticipantList=[];
      this.emailAssigned="";
      this.ShowEmailBox=false;
      this.ShowUserBox=false;
      this.ShowRoleBox=false;
      this.ShowCoreBox=true;
      this.ShowContactBox=false;
      this.ShowCompanyBox=false; 

      this.textNameShow=this.CoreShowName;
    }
     // Contact=2
     if(this.typeOfParticipant==2){
      this.addUpdateParticipantList=[];
      this.emailAssigned="";
      this.ShowEmailBox=false;
      this.ShowUserBox=false;
      this.ShowRoleBox=false;
      this.ShowCoreBox=false;
      this.ShowContactBox=true;
      this.ShowCompanyBox=false; 

      this.textNameShow=this.ContactShowName;
    }
     // Company=3
     if(this.typeOfParticipant==3){
      this.addUpdateParticipantList=[];
      this.emailAssigned="";
      this.ShowEmailBox=false;
      this.ShowUserBox=false;
      this.ShowRoleBox=false;
      this.ShowCoreBox=false;
      this.ShowContactBox=false;
      this.ShowCompanyBox=true; 

      this.textNameShow=this.CompanyShowName;
    }
  }

  removeParticipant(item: any) {
    const index = this.addUpdateParticipantList.indexOf(item);
    if (index >= 0) {
      this.addUpdateParticipantList.splice(index, 1);      
    }
    if (this.addUpdateParticipantList.length > 0) {
     
    }
  }


  //==== For Add Email================//

  addEmail() {    
    if (this.addUpdateParticipantList.length > 0) {
      return;
    }
      var check = [];
      check = this.addUpdateParticipantList.filter(x => x.email.toLowerCase() == this.emailAssigned.toLowerCase()
      && x.typeOfParticipant==0)
  
      let toArray =  this.emailAssigned.split("@");
      var shortName = toArray[0].match(/\b(\w)/g).join('');    
      if (check.length == 0) {
        var obj={
          name: "",       
          email: this.emailAssigned,
          coreID: 0,
          contactID: 0,
          companyID:0,
          role:  0,
          userID: null,
          typeOfParticipant:0,
          img: "",
          shortName:shortName
        }
        this.addUpdateParticipantList.push(obj);      
        this.emailAssigned = "";
        this.addEmailButtonShow = false;
  
      } else {
        this.emailAssigned = "";
        this.addEmailButtonShow = false;
        this.toastr.warning('Email allready added.', '', {
          timeOut: 3000,
        });
      }  
  }

  emailCheck(searchValue: any) {
    if (searchValue.toLowerCase() == searchValue.toLowerCase().match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')) {
       this.emailAssigned = searchValue;
      this.addEmailButtonShow = true;
    } else {
      this.addEmailButtonShow = false;
    }
  }


  //====== For Add User ================//

  userSelectedNew(userSelected: any) {
    this.stateCtrl.setValue('');
    if (this.addUpdateParticipantList.length > 0) {
      return;
    }
    var user=[];
    user = this.addUpdateParticipantList.filter(x => x.userID == userSelected.userID && x.typeOfParticipant==1);
    if (user.length==0) {   
      var shortName = userSelected.firstName.match(/\b(\w)/g).join('');
      var obj={
        name: userSelected.firstName + " " + userSelected.lastName,    
        email: userSelected.email,
        coreID: 0,
        contactID: 0,
        companyID:0,
        userID: userSelected.uuid,
        typeOfParticipant:1,
        img: "",
        shortName:shortName
      }
      this.addUpdateParticipantList.push(obj);        
    }else{
      this.toastr.warning('User allready added.', '', {
        timeOut: 3000,
      });
    }
    if(this.addUpdateParticipantList.length > 0){
      this.showAddButton=true;
    }
    else{
      this.showAddButton=false;
    } 
   
  }


   //====== For Add Role  ================//

  roleSelectedNew(roleSelected: any) {
    this.stateCtrl.setValue('');
    if (this.addUpdateParticipantList.length > 0) {
      return;
    }
    var newRole=[];   
    newRole = this.addUpdateParticipantList.filter(x => x.roleID == roleSelected.roleID && x.typeOfParticipant==5);
    if (newRole.length==0) {
     
      var shortName = roleSelected.roleName.match(/\b(\w)/g).join('');
     
      var obj={
        name: roleSelected.roleName, 
        email: "",
        coreID: 0,
        contactID: 0,
        companyID:0,
        role:  roleSelected.roleID,
        userID: null,
        typeOfParticipant:5,
        img: "",
        shortName:shortName
      }
      this.addUpdateParticipantList.push(obj);   
      // if (this.selectedAssignedTo.length > 0) {
      //   this.showTaskUpdateButton = true;
      // }
      // if (this.selectedAssignedTo.length == 0) {
      //   this.showTaskUpdateButton = false;
      // }
    }else{       
      this.toastr.warning('Role allready added.', '', {
        timeOut: 3000,
      });    
  }

    // if (this.selectedAssignedTo.length > 0) {
    //   this.showTaskUpdateButton = true;
    // }  
  
  }

  //====== For Add Core  ================//

  coreSelectedNew(coreSelected: any) {
    // if(coreSelected.coreID == 0) { 
    //   this.dialog.closeAll();
    //   this.addNew('Core');
    //   return ;
    //  }
    if (this.addUpdateParticipantList.length > 0) {
      return;
    }
    // if(coreSelected.email=="" || coreSelected.email==null || coreSelected.email==undefined){
    //   this.toastr.warning('Selected '+this.contactNames+' is not added email id.', '', {
    //     timeOut: 3000,
    //   });
    //   return;
    // }
    this.stateCtrl.setValue('');
    var shortName = "";
    shortName = coreSelected.name.match(/\b(\w)/g).join('');
     
    var obj={
      name: coreSelected.name,
      email: coreSelected.email,
      coreID: coreSelected.coreID,
      contactID: 0,
      companyID:0,
      role:  0,
      userID: null,
      typeOfParticipant:1,
      img: coreSelected.imageUrl,
      shortName:shortName
    }
    this.addUpdateParticipantList.push(obj);   
    // if (this.selectCoreList.length > 0) {
    //   this.showAddButton = true;
    // }else {
    //   this.showAddButton = false;
    // }
  } 

 //====== For Add Contact  ================//
  contactSelectedNew(contactSelected: any) {
    // if(coreSelected.coreID == 0) { 
    //   this.dialog.closeAll();
    //   this.addNew('Core');
    //   return ;
    //  }
    if (this.addUpdateParticipantList.length > 0) {
      return;
    }
    // if(coreSelected.email=="" || coreSelected.email==null || coreSelected.email==undefined){
    //   this.toastr.warning('Selected '+this.contactNames+' is not added email id.', '', {
    //     timeOut: 3000,
    //   });
    //   return;
    // }
    this.stateCtrl.setValue('');
    var shortName = "";
    shortName = contactSelected.name.match(/\b(\w)/g).join('');
     
    var obj={
      name: contactSelected.name,
      email: contactSelected.email,
      coreID: 0,
      contactID: contactSelected.contactID,
      companyID:0,
      role:  0,
      userID: null,
      typeOfParticipant:2,
      img: contactSelected.imageUrl,
      shortName:shortName
    }
    this.addUpdateParticipantList.push(obj);   
    // if (this.selectCoreList.length > 0) {
    //   this.showAddButton = true;
    // }else {
    //   this.showAddButton = false;
    // }
  } 

  //====== For Add Company  ================//
  companySelectedNew(companySelected: any) {
    // if(coreSelected.coreID == 0) { 
    //   this.dialog.closeAll();
    //   this.addNew('Core');
    //   return ;
    //  }
    if (this.addUpdateParticipantList.length > 0) {
      return;
    }
    // if(coreSelected.email=="" || coreSelected.email==null || coreSelected.email==undefined){
    //   this.toastr.warning('Selected '+this.contactNames+' is not added email id.', '', {
    //     timeOut: 3000,
    //   });
    //   return;
    // }
    this.stateCtrl.setValue('');
    var shortName = "";
    shortName = companySelected.name.match(/\b(\w)/g).join('');
     
    var obj={
      name: companySelected.name,
      email: companySelected.email,
      coreID: 0,
      contactID: 0,
      companyID: companySelected.companyID,
      role:  0,
      userID: null,
      typeOfParticipant:2,
      img: companySelected.imageUrl,
      shortName:shortName
    }
    this.addUpdateParticipantList.push(obj);   
    // if (this.selectCoreList.length > 0) {
    //   this.showAddButton = true;
    // }else {
    //   this.showAddButton = false;
    // }
  } 

  getSelectedLabel(value: number): string {
    switch (value) {
      case 0: return 'Email';
      case 1: return this.CoreShowName;
      case 2: return this.ContactShowName;
      case 3: return this.CompanyShowName;
      case 4: return 'User';
      case 5: return 'Role';
      default: return '';
    }
  }

  
  ShowcolourCode = [{
    colourCode: '#FF9E80',
  }, {
    colourCode: '#FFE0B2',
  }, {
    colourCode: '#F0F4C3',
  }, {
    colourCode: '#CCFF90',
  }, {
    colourCode: '#EA80FC',
  }, {
    colourCode: '#FAD980',
  }, {
    colourCode: '#84FFFF',
  }, {
    colourCode: '#B3E5FC',
  }, {
    colourCode: '#B9F6CA',
  }, {
    colourCode: '#FFE57F',
  }, {
    colourCode: '#8C9EFF',
  }, {
    colourCode: '#82B1FF',
  }, {
    colourCode: '#FF80AB',
  }, {
    colourCode: '#E7F4E4',
  }, {
    colourCode: '#B9F6CA',
  }, {
    colourCode: '#A7FFEB',
  }, {
    colourCode: '#FFFF8D',
  }, {
    colourCode: '#DCE4EF',
  }, {
    colourCode: '#D7CCC8',
  }, {
    colourCode: '#D1C4E9',
  }, {
    colourCode: '#CCFF90',
  }, {
    colourCode: '#FFCDD2',
  }, {
    colourCode: '#D6D7D9',
  }, {
    colourCode: '#DCEDC8',
  }, {
    colourCode: '#EBBFCB',
  }, {
    colourCode: '#DA8E9E',
  }, {
    colourCode: '#AAC5EC',
  }, {
    colourCode: '#F8EEC9',
  }, {
    colourCode: '#DFC0DC',
  }, {
    colourCode: '#F8E1DF',
  }, {
    colourCode: '#D2DDF2',
  }, {
    colourCode: '#D6ECFB',
  }, {
    colourCode: '#D4DCE0',
  }, {
    colourCode: '#D4E8D9',
  }, {
    colourCode: '#CECCE8',
  }, {
    colourCode: '#FBEFEC',
  }, {
    colourCode: '#DCBED4',
  }, {
    colourCode: '#F8EAD7',
  }, {
    colourCode: '#A9D4C5',
  }, {
    colourCode: '#DCE4D1',
  }, {
    colourCode: '#FFEFE7',
  }, {
    colourCode: '#F4BCB8',
  }, {
    colourCode: '#CEDCC7',
  }, {
    colourCode: '#EBEEC4',
  }, {
    colourCode: '#D5DCAC',
  }, {
    colourCode: '#F5E5C9',
  }, {
    colourCode: '#DFC3B7',
  }, {
    colourCode: '#BECAD3',
  }, {
    colourCode: '#FBDECC',
  }, {
    colourCode: '#EFC7C3',
  }
  ]
}
